/* eslint-disable no-unused-vars */
import React from "react";
import { Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";
import { FirstName, LastName } from "../../utils/getName";

import './About.css';

import profile from '../../assets/profile1.png';

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: '100vw',
    marginTop: '3em',
    marginBottom: "auto",
  },
}));

export const About = () => {
  const classes = useStyles();
  const greetings = "Hello there!";
  const aboutme = `I'm ${FirstName} ${LastName}, a multidisciplinary 
                  full stack developer & ML engineer. I'm always down for something new and challenging!
                  I specialize in creating beautifully formatted full-stack applications and building intelligent ML solutions. 
                  My projects include full stack web development, machine learning applications, and IoT systems.`;

  return (
    <section id="about">
      <Container component="main" className={classes.main} maxWidth="md">
        <div className="about" >
          <div className="_img-modern">
            <div className="profile-image-wrapper">
              <img 
                src={profile} 
                alt={`${FirstName} ${LastName}`}
                className="profile-image"
              />
              <div className="image-border"></div>
            </div>
          </div>
          <div className="_content_wrapper">
            <Typography component='h2' variant="h5" className="greeting-title">
              <TextDecrypt text={`${greetings}`} />
            </Typography>
            <p className="aboutme">
              {aboutme}
            </p>
            <a href="mailto:princeniiyarteyannan@gmail.com" className="contact-btn">
              <i className="fas fa-terminal"></i>
              <Typography component='span'> Send me a message.</Typography>
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
};
